<div class='editor__wrapper mat-form-field-wrapper'>
    <div class="editor">
        <quill-editor name="editor" [formControl]="form" ngDefaultControl></quill-editor>
    </div>
</div>

